// Schedule only the next actual break expiry, not a repeating board GET.
// The remaining seconds come from the backend, so a smartboard clock that is
// slightly ahead/behind the server does not change the expected deadline.
export const BOARD_COOLDOWN_REFRESH_GRACE_MS = 250;
export const BOARD_COOLDOWN_RETRY_MS = 30000;
const MAX_TIMEOUT_MS = 2147483647;

export function nextBoardCooldownRefreshDelay(students, boardReceivedAt, now = Date.now()) {
  const deadlines = (students || [])
    .filter((student) => Boolean(student.cooldown_until))
    .map((student) => {
      const remaining = Number(student.cooldown_remaining_seconds);
      if (Number.isFinite(remaining) && remaining > 0) {
        return boardReceivedAt + remaining * 1000;
      }
      // A malformed or rounded-to-zero remaining time cannot leave a
      // paused student stuck forever; ask the server to confirm shortly.
      return now;
    });
  if (!deadlines.length) return null;
  return Math.min(MAX_TIMEOUT_MS, Math.max(0, Math.min(...deadlines) - now)
    + BOARD_COOLDOWN_REFRESH_GRACE_MS);
}
